import React, { useCallback } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FlatButton } from "src/framework/components/buttons/FlatButton";

import { useObservable } from "src/framework/store/storeUtil";
import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import theme from "src/theme/light";
import { IConfirmationDialog, openDialogConfirmation$, setupDialog$ } from "src/framework/store/ConfirmationDialogStore";

const Confirmation = () => {
  const open = useObservable<boolean>(openDialogConfirmation$);
  const setup = useObservable<IConfirmationDialog>(setupDialog$)

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const RenderIcon = useCallback(()=>{
    if (!setup?.headerIcon) return null
    return setup.headerIcon
  },[setup])

  return (
    <div>
      <Dialog
        className={setup?.className}
        maxWidth={setup?.maxWidth || 'sm'}
        open={open || false}
        onClose={() => {
          setup?.onClose();
        }}
      >
        <DialogTitle id="simple-dialog-title">
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Box>
              {setup?.title}
              <Typography variant='body2' color='textSecondary'>
                {setup?.subtitle}
              </Typography>
            </Box>
            <Box>
              <RenderIcon />
            </Box>
          </Box>
        </DialogTitle>

        <Box paddingBottom={2}>
          <Divider />
        </Box>

        <DialogContent
          style={{
            minWidth: isMobile ? "100%" : (setup?.size || "300px"),
          }}
        >
          <DialogContentText id="alert-dialog-description">
            {setup?.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          { setup?.customButtons || (<>
            {!setup?.onlyConfirm && (
                <FlatButton
                  variant="outlined"
                  onClick={() => {
                    if (setup?.onNegation) {
                      setup?.onNegation();
                    }
                    setup?.onClose();
                  }}
                  color="secondary"
                  text={setup?.noText || "Não"}
                />
              )}
              <FlatButton
                onClick={() => {
                  if (setup?.onConfirmation) {
                    setup?.onConfirmation();
                  }
                  if (setup?.propagateWhenConfirm) {
                    setup?.onClose();
                  }
                }}
                color="primary"
                className={setup?.submitButtonClassName}
                variant="contained"
                text={setup?.yesText || "Sim"}
              />
            </>)
          }
 
        </DialogActions>
      </Dialog>
    </div>
  );
};

export { Confirmation };
